import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { provideMarkdown } from 'ngx-markdown';
import { routes } from './app.routes';

import { registerLocaleData } from '@angular/common';
import localeLv from '@angular/common/locales/lv';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { NgcCookieConsentConfig, provideNgcCookieConsent } from 'ngx-cookieconsent';
import { AuthorizationService } from 'services/authorization.service';
import { AuthInterceptor } from './interceptor/auth.interceptor';

export function getLocaleProviders() {
  registerLocaleData(localeLv, 'lv');
  return { provide: LOCALE_ID, useValue: 'lv' };
}

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: window.location.hostname
  },
  position: 'bottom',
  theme: 'classic',
  palette: {
    popup: {
      background: '#38bfff',
      text: '#ffffff',
      link: '#ffffff'
    },
    button: {
      background: '#d1f0ff',
      text: '#000000',
      border: 'transparent'
    }
  },
  type: 'info',
  content: {
    message:
      '"lna.lv" izmanto obligātās, analītiskās, mārketinga un citas sīkdatnes. Šie faili ir nepieciešami, lai nodrošinātu visu pakalpojumu nevainojamu darbību, tie palīdz mums atcerēties jūs un jūsu personiskos iestatījumus. ',
    dismiss: 'Sapratu!',
    deny: 'Refuse cookies',
    link: 'Lai iegūtu sīkāku informāciju, lūdzu, izlasiet sīkdatņu politiku',
    href: 'https://lna.lv',
    policy: 'Cookie Policy'
  }
};

function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const provideTranslation = () => ({
  defaultLanguage: 'lv',
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient]
  }
});

const initializeApp = (authorizationService: AuthorizationService) => {
  return async () => await authorizationService.configure();
};

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [AuthorizationService]
    },
    provideNgcCookieConsent(cookieConfig),
    provideRouter(routes, withComponentInputBinding()),
    provideClientHydration(),
    provideHttpClient(withFetch()),
    provideClientHydration(),
    provideMarkdown(),
    importProvidersFrom([HttpClientModule, TranslateModule.forRoot(provideTranslation())]),
    provideOAuthClient(),
    getLocaleProviders(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
};
